import { AxiosRequestConfig } from "axios";
import { HttpMethod, Endpoint, EndpointMap } from "./interfaces";

const parseEnvBoolean = (value?: string): boolean =>
  ["true", "1", "yes", "on"].includes((value ?? "").trim().toLowerCase());

// general configuration
export const projectName = "id.express";
export const projectApiUrl = process.env.REACT_APP_API_URL;
export const dictionaryApiUrl =
  process.env.REACT_APP_GUN_DICTIONARY_API_BASE_URL ||
  projectApiUrl?.replace("api.id.express/v1", "api-dictionary.id.express/v1/dictionaries") ||
  "https://qa-api-dictionary.id.express/v1/dictionaries";
export const projectBasename = "/"; // base path 
export const defaultLanguage = "en";

export const cookieSameSite = (process.env.REACT_APP_COOKIE_SAMESITE ?? "Lax") as "Lax" | "Strict" | "None";
export const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN ?? undefined;
export const cookieSecure = parseEnvBoolean(process.env.REACT_APP_COOKIE_SECURE);
export const cookieHttpOnly = parseEnvBoolean(process.env.REACT_APP_COOKIE_HTTPONLY);
export const reactAppDebug = parseEnvBoolean(process.env.REACT_APP_DEBUG);
const authCookiePrefix = (process.env.REACT_APP_AUTH_COOKIE_PREFIX || "x").trim() || "x";
export const authAccessTokenCookieName = `${authCookiePrefix}-auth-token`;
export const authRefreshTokenCookieName = `${authCookiePrefix}-refresh-token`;
export const authAppIdCookieName = `${authCookiePrefix}-app-id`;



// apiEndpoints
const endpointMap: EndpointMap = {
  login: `${projectApiUrl}/login`,
  oneclicklogin: `${projectApiUrl}/oneclicklogin`,
  logout: `${projectApiUrl}/logout`,
  registration: `${projectApiUrl}/registration`,
  resendcode: `${projectApiUrl}/resendcode`,
  activation: `${projectApiUrl}/activation`,
  languages: `${dictionaryApiUrl}?type=language&fields=value.default.name,metadata.flag,metadata.iso_639_1`,
  get_csrf_token: `${projectApiUrl}/get_csrf_token`,
  apps: `${dictionaryApiUrl}?type=app&fields=_id,key,status,sortOrder,metadata`,
  resetpassword: `${projectApiUrl}/resetpassword`,
  confirmation: `${projectApiUrl}/confirmation`,
  refresh: `${projectApiUrl}/refresh`,
  activesession: `${projectApiUrl}/activesession`,
};

// configuration for Axios

/**
 * Generates a dynamic Axios request configuration object.
 *
 * @param {HttpMethod} method - The HTTP method (e.g., "get", "post", "put", "delete").
 * @param {Endpoint} endpoint - The API endpoint name (e.g., "login", "registration").
 * @param {Object} data - The request payload data (used in the request body).
 * @param {Object} headers - Additional headers to be included in the request.
 * @param {Object} params - URL parameters to be included in the request.
 * @returns {AxiosRequestConfig} - The Axios request configuration object.
 */
export const generateRequestConfig = (
  method: HttpMethod,
  endpoint: Endpoint,
  data: object,
  headers: Record<string, string | null> = {},
  params: Record<string, string | number | null | undefined> = {} 
): AxiosRequestConfig => {
  const url = endpointMap[endpoint];

  if (!url) {
    throw new Error(`Invalid endpoint: ${endpoint}`);
  }

  return {
    method,
    url,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      ...headers,
    },
    data,
    params,
    withCredentials: true 
  };
};

// validation
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 32;
